import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  class: "form"
};
import CustomBar from "@/components/customBar";
import { ref } from "vue";
import { redeemTransfer } from "@/api/index";
import { usebaseRouter } from "@/utils/hooks";
import PayPwd from "@/components/payPwd";

import { showToast, showConfirmDialog } from 'vant/es';
import 'vant/es/toast/style/index';
import 'vant/es/dialog/style/index';
export default {
  __name: 'index',
  setup(__props) {
    const {
      back
    } = usebaseRouter();
    const childRef = ref();
    const params = ref({
      toAccount: '',
      qty: '',
      payPasswd: ''
    });
    const handlePwd = pwd => {
      params.value.payPasswd = pwd;
      redeemTransfer(params.value).then(() => {
        showToast('积分转让成功');
        back();
      });
    };
    const submit = () => {
      if (!params.value.toAccount) return showToast('请输入接收账号');
      if (!params.value.qty) return showToast('请输入转让数量');
      showConfirmDialog({
        title: '提示',
        message: '是否确认转让？'
      }).then(() => {
        params.value.payPasswd = '';
        childRef.value.setShow(true);
      });
    };
    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: "积分转让"
      }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("input", {
        class: "form-input icon4",
        type: "tel",
        maxlength: "11",
        placeholder: "请输入接收账号",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => params.value.toAccount = $event)
      }, null, 512), [[_vModelText, params.value.toAccount]]), _withDirectives(_createElementVNode("input", {
        class: "form-input icon10",
        type: "tel",
        placeholder: "请输入转让数量",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => params.value.qty = $event)
      }, null, 512), [[_vModelText, params.value.qty]]), _createVNode(_component_van_button, {
        type: "primary",
        large: "",
        round: "",
        block: "",
        class: "savebtn",
        onClick: submit
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("转让")])),
        _: 1
      }), _createElementVNode("div", {
        class: "hint",
        onClick: _cache[2] || (_cache[2] = $event => _ctx.$router.push('record?type=1'))
      }, "转让记录")])]), _createVNode(_unref(PayPwd), {
        ref_key: "childRef",
        ref: childRef,
        onSuccess: handlePwd
      }, null, 512)], 64);
    };
  }
};